import { Typography } from '@mui/material';
import ODSIcon from '@telekom-ods/react-icons/ODSIcon';
import { type FC } from 'react';
import { useIntl } from 'react-intl';

interface ErrorObject {
  message: string;
}

interface AlertProps {
  error?: ErrorObject;
}

const Alert: FC<AlertProps> = ({ error = { message: 'defaultErrorMessage' } }) => {
  const intl = useIntl();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
      }}
    >
      <ODSIcon
        name='error-type-standard'
        style={{ color: '#d32f2f' }}
      />
      <Typography
        variant='h5'
        color='error'
        align='center'
      >
        {intl.formatMessage({ id: error.message || 'defaultErrorMessage' })}
      </Typography>
    </div>
  );
};

export default Alert;
